import React, { AriaRole } from "react";
import { SanityImageSourceExt } from "../models/shared/SanityImageSourceExt";
import { Breakpoint, BreakpointValues } from "../utilities/breakpoints";
import {
  getImageAltText,
  getImagePresetUrl,
  ImagePresetCollection,
  ImageSource
} from "../utilities/image";

export interface PictureProps {
  className?: string;
  image: SanityImageSourceExt;
  imgClassName?: string;
  presets: ImagePresetCollection;
  imgLoading?: "eager" | "lazy";
  imgRole?: AriaRole;
}

const sourceBreakpointOrdering: Breakpoint[] = [
  Breakpoint["3xl"],
  Breakpoint["2xl"],
  Breakpoint.xl,
  Breakpoint.lg,
  Breakpoint.md,
  Breakpoint.sm
];

export const Picture = ({
  className,
  image,
  imgClassName,
  presets,
  imgLoading,
  imgRole
}: PictureProps) => {
  const sources: ImageSource[] = [];

  for (const breakpoint of sourceBreakpointOrdering) {
    const preset = presets[breakpoint];

    if (preset) {
      sources.push({
        minimumBreakpoint: BreakpointValues[breakpoint],
        srcSet: getImagePresetUrl(image, preset) ?? "",
        preset
      });
    }
  }

  return (
    <picture className={className}>
      {sources.map((source, i) => (
        <source
          key={i}
          media={`(min-width: ${source.minimumBreakpoint}px)`}
          srcSet={source.srcSet}
          height={source.preset.height}
          width={source.preset.width}
        />
      ))}
      <img
        alt={getImageAltText(image)}
        className={imgClassName}
        src={getImagePresetUrl(image, presets.default) ?? ""}
        height={presets.default.height}
        width={presets.default.width}
        loading={imgLoading}
        role={imgRole}
      />
    </picture>
  );
};

